import { DELETE_SCHEDULED_REPORT_ERROR, DELETE_SCHEDULED_REPORT_SUCCESS } from './actionTypes';

export const deleteScheduledReportSuccess = report => ({ type: DELETE_SCHEDULED_REPORT_SUCCESS, payload: report });

export const deleteScheduledReportError = error => ({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: error });
